import { LEADERBOARD_ACTION } from '../../constants/actions'
import { mergeToNewObject } from '../../util/object.helpers'

const leaderboardReducer = (state, { type, payload }) => {
  switch (type) {
    case LEADERBOARD_ACTION.CHANGE_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    case LEADERBOARD_ACTION.RESET_STATE:
      return mergeToNewObject(state, {
        loading: false,
        error: {}
      })

    case LEADERBOARD_ACTION.GET_DATA:
      return mergeToNewObject(state, { loading: true })

    case LEADERBOARD_ACTION.GET_DATA_SUCCESS:
      return mergeToNewObject(
        state,
        { loading: false },
        handleLeaderboardDataResponse(payload)
      )

    case LEADERBOARD_ACTION.GET_DATA_FAILED:
      return mergeToNewObject(state, { loading: false })

    default:
      return state
  }
}

const leaderboardInitialState = {
  loading: false,
  topRankings: [],
  communityRankings: [],
  error: {}
}

const LEADERBOARD_PROFILE_DISPATCH = {
  LOADING: 'loading',
  ERROR: 'error'
}

export {
  leaderboardReducer,
  leaderboardInitialState,
  LEADERBOARD_PROFILE_DISPATCH
}

const handleLeaderboardDataResponse = (payload) => {
  const result = {
    topRankings: [],
    communityRankings: []
  }
  if (payload.individual) {
    const individualRanks = Object.keys(payload.individual)
    if (individualRanks.length) {
      result.topRankings = individualRanks.map((rank) => {
        return {
          ...payload.individual[rank]
        }
      })
    }
  }
  if (payload.communities) {
    const communityRanks = Object.keys(payload.communities)
    if (communityRanks.length) {
      communityRanks.forEach((rank) => {
        result.communityRankings.push({
          ...payload.communities[rank]
        })
      })
    }
  }
  return result
}
